import React, { useState, useContext } from 'react';
import {
    TextBox, RadioButton, SelectOption,TextArea,AceEditor,DraftEditor
} from 'info-ui-library';
import styled from 'styled-components';
import { themes } from '../theme/ThemeOptions';
import { useSelector, useDispatch } from 'react-redux';
import { getPropertyByFormFieldType } from "../utils/PropertyUtils";
import formFieldTypeOptions from "./mockData/formFieldTypeOptions.json";
import { ThemeContext } from '../theme/ThemeContext';
import { setChangeFormData } from '../actions/index';
import PortalCardComponent from './PortalCardComponent';
import FormSelectOption from './FormSelectOption';
import GridSelectOption from './GridSelectOption';
import DataSourceSelectOption from './DataSourceSelectOption';
import PortalSelectOption from './PortalSelectOption';
import CompositeEntitySelectOption from './CompositeEntitySelectOption';
const InnerContainer = styled.div`{
    flex: 1 0 21%;
    padding-right:5px;
}`;
const OuterConatiner = styled.div`
display: flex;
flex-wrap: wrap;
`;

const handlePropertyChange = (updatedValue, dbCode, type, dispatch) => {
    dispatch(setChangeFormData("test555", updatedValue && updatedValue.value ? updatedValue.value : updatedValue, dbCode, type));
}

const onBlur = (updatedValue, dbCode, type, dispatch) => {
    dispatch(setChangeFormData("test555", updatedValue && updatedValue.value ? updatedValue.value : updatedValue, dbCode, type));
}

const getComponents = (properties, formData, setFormData, errorData, dispatch, themeContext) => {
    try {
        return properties.map(property => {
            switch (property.type) {
                case "TextBox":
                    return <InnerContainer><TextBox
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        label={property.label}
                        configId={property.label}
                        key={property.label}
                        value={Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ? formData.property[property.dbCode] : property.defaultValue}
                        displayType="FloatingLabel"
                        handleChange={(updatedValue) => {
                            handlePropertyChange(updatedValue, property.dbCode, "property", dispatch)
                        }}

                        onBlur={(updatedValue) => {
                            onBlur(updatedValue, property.dbCode, "property", dispatch)
                        }}
                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false}
                        mandatory={property.isMandatory}
                        isButtonTextBox={false}
                    /></InnerContainer>
                case "TextArea":
                    return <InnerContainer><TextArea
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        label={property.label}
                        configId={property.label}
                        key={property.label}
                        value={Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ? formData.property[property.dbCode] : property.defaultValue}
                        displayType="FloatingLabel"
                        handleChange={(updatedValue) => {
                            handlePropertyChange(updatedValue, property.dbCode, "property", dispatch)
                        }}

                        onBlur={(updatedValue) => {
                            onBlur(updatedValue, property.dbCode, "property", dispatch)
                        }}

                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false}
                        mandatory={property.isMandatory}
                        isButtonTextBox={false}
                    /></InnerContainer>
                case "SelectOption":
                    const valueAsAnObject = getValueObject(Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ?
                        formData.property[property.dbCode] : property.defaultValue, property.options)
                    return <InnerContainer><SelectOption
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        value={valueAsAnObject}
                        label={property.label}
                        configId={property.label}
                        key={property.label}
                        options={property.options}
                        displayType="FloatingLabel"
                        onChange={(updatedValue) => {
                            handlePropertyChange(updatedValue, property.dbCode, "property", dispatch)
                        }}
                        isSearchable={true}
                        isDisabled={false}
                        isMulti={false}
                        mandatory={property.isMandatory}
                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false}
                    /></InnerContainer>
                case "RadioButton":
                    return <InnerContainer> <RadioButton
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        label={property.label}
                        configId={property.label}
                        key={property.label}
                        options={property.options}
                        value={Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ? formData.property[property.dbCode] : property.defaultValue}
                        onChange={(updatedValue) => {
                            handlePropertyChange(updatedValue, property.dbCode, "property", dispatch)
                        }}
                        displayType="FloatingLabel"
                        mandatory={property.isMandatory}
                        disabled={false}
                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false}
                    /></InnerContainer>
                case "DataSource":
                    const values = Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ?
                        formData.property[property.dbCode] : property.defaultValue;
                    return <InnerContainer><DataSourceSelectOption
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        selectedValue={values}
                        label={property.label}
                        key={property.label}
                        options={property.options}
                        displayType="FloatingLabel"
                        handleSelectOption={handlePropertyChange}
                        isSearchable={true}
                        isDisabled={false}
                        isMulti={false}
                        property={property}
                        mandatory={property.isMandatory}
                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false} /></InnerContainer>
                case "Portal":
                    const portalvalues = Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ?
                        formData.property[property.dbCode] : property.defaultValue;
                    return <InnerContainer><PortalSelectOption
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        selectedValue={portalvalues}
                        label={property.label}
                        key={property.label}
                        options={property.options}
                        displayType="FloatingLabel"
                        handleSelectOption={(updatedValue) => {
                            handlePropertyChange(updatedValue, property.dbCode, "property", dispatch)
                        }}
                        isSearchable={true}
                        isDisabled={false}
                        isMulti={false}
                        property={property}
                        mandatory={property.isMandatory}
                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false} /></InnerContainer>
                
                case "Form":
                    const formvalues = Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ?
                        formData.property[property.dbCode] : property.defaultValue;
                    return <InnerContainer><FormSelectOption
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        selectedValue={formvalues}
                        label={property.label}
                        key={property.label}
                        options={property.options}
                        displayType="FloatingLabel"
                        handleSelectOption={handlePropertyChange}
                        isSearchable={true}
                        isDisabled={false}
                        isMulti={false}
                        property={property}
                        mandatory={property.isMandatory}
                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false} /></InnerContainer>
                case "Grid":
                    const gridValues = Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ?
                        formData.property[property.dbCode] : property.defaultValue;
                    return <InnerContainer><GridSelectOption
                        ioTheme={themes[0]}
                        ioMode={themeContext.ioMode}
                        styleName={themeContext.styleName}
                        selectedValue={gridValues}
                        label={property.label}
                        key={property.label}
                        options={property.options}
                        displayType="FloatingLabel"
                        handleSelectOption={handlePropertyChange}
                        isSearchable={true}
                        isDisabled={false}
                        isMulti={false}
                        property={property}
                        mandatory={property.isMandatory}
                        errorMessage={errorData[property.dbCode]}
                        hasError={errorData[property.dbCode] ? true : false} /></InnerContainer>
                case "CardType":
                    return <InnerContainer><PortalCardComponent 
                    formData ={formData} setFormData={setFormData} errorData={errorData}/></InnerContainer>
                    case "CodeEditor":
                    const editorValues = Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ?
                        formData.property[property.dbCode] : property.defaultValue;
                    return <InnerContainer>
                        <AceEditor
                        mode={"javascript"}
                        collapseEnable={false}
                            id={property.label}
                            label={property.label}
                            configId={property.label}
                            ioTheme={themes[0]}
                            ioMode={themeContext.ioMode}
                            styleName={themeContext.styleName}
                            mandatory={property.isMandatory}
                            editorTheme="solarized_dark"
                            editorMode={property.editorMode}
                            handleChange={(updatedValue) => {
                                handlePropertyChange(updatedValue, property.dbCode, "property", dispatch)
                            }}
                            value={editorValues}
                            fontSize={14}
                            showGutter={false}
                            enableBasicAutocompletion={true}
                            enableLiveAutocompletion={true}
                            showLineNumbers={true}
                            errorMessage={errorData[property.dbCode]}
                            hasError={errorData[property.dbCode] ? true : false}
                        />
                    </InnerContainer>
                    case "CkEditor":
                        return <InnerContainer><DraftEditor
                            ioTheme={themes[0]}
                            ioMode={themeContext.ioMode}
                            styleName={themeContext.styleName}
                            label={property.label}
                            configId={property.label}
                            key={property.label}
                            value={Object.keys(formData.property).length > 0 && formData.property[property.dbCode] ? formData.property[property.dbCode] : property.defaultValue}
                            displayType="FloatingLabel"
                            handleChange={(updatedValue) => {
                                handlePropertyChange(updatedValue, property.dbCode, "property", dispatch)
                            }}
                            errorMessage={errorData[property.dbCode]}
                            hasError={errorData[property.dbCode] ? true : false}
                            mandatory={property.isMandatory}
                            toolbarHidden={false}
                            readOnly={property.readonly}
                        /></InnerContainer>
            
            }
        })
    } catch (e) {
        return <div>{}</div>
    }

}

const handleSelectType = (updatedValue, setType, dbCode, formData, dispatch) => {
    //console.log(updatedValue);
    let dataMap = formData;
    dataMap.property[dbCode] = updatedValue.value;
    setType(updatedValue.value);
    dispatch(setChangeFormData("test555", updatedValue && updatedValue.value ? updatedValue.value : updatedValue, dbCode, "property"));

}
const FormFieldPropertyComponent = props => {
    const themeContext = useContext(ThemeContext);
    const dispatch = useDispatch();
    const [type,
        setType] = useState(Object.keys(props.formData.property).length>0?
        props.formData.property["type"]:"");
    let components = "";
    if (type !== "") {
        const property = getPropertyByFormFieldType(type);
        components = getComponents(property, props.formData, props.setFormData,
             props.errorData, dispatch, themeContext);
        Object.assign(props.formData.property, property)
    }else{
        const  propertyMap= [ 
            { dbCode: "type", 
            isMandatory: true ,
            }];
        Object.assign(props.formData.property, propertyMap)
    }
    const valueAsAnObject = getValueObject(Object.keys(props.formData.property).length > 0 && props.formData.property["type"] ?
        props.formData.property["type"] : "", formFieldTypeOptions)

    try {
        return (
            <OuterConatiner className="col-md-12" >
                <InnerContainer><SelectOption
                    ioTheme={themes[0]}
                    ioMode={themeContext.ioMode}
                    styleName={themeContext.styleName}
                    value={valueAsAnObject}
                    label="Type"
                    configId={"Type"}
                    key="Type"
                    options={formFieldTypeOptions}
                    displayType="FloatingLabel"
                    onChange={(value) => handleSelectType(value, setType,
                        "type", props.formData,dispatch)}
                    isSearchable={true}
                    isDisabled={false}
                    isMulti={false}
                    mandatory={true}
                    errorMessage={props.errorData["type"]}
                    hasError={props.errorData["type"] ? true : false}
                /></InnerContainer>
                {components}
            </OuterConatiner>

        )
    } catch (e) {
        return <div></div>
    }
}

export const getValueObject = (initialvalue, selectedOptions) => {
    let value = null
    if (selectedOptions) {
        selectedOptions.map(object => {
            if (String(object.id) === String(initialvalue)) {
                value = object;
            }
            return null;
        })
    }
    return value
}
export default FormFieldPropertyComponent;